var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgExpiredStatus(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.933,14.25v-.005L8.433,1.255c-.158-.239-.48-.305-.719-.147-.058.039-.108.089-.147.147L.067,14.245c-.141.238-.062.544.175.685.078.046.167.07.258.07h15c.276,0,.5-.224.5-.5,0-.088-.023-.174-.067-.25ZM7.25,5.741c0-.414.336-.75.75-.75s.75.336.75.75v3.5c0,.414-.336.75-.75.75s-.75-.336-.75-.75v-3.5ZM8,13c-.552,0-1-.448-1-1s.448-1,1-1,1,.448,1,1-.448,1-1,1Z",
    fill: "#484848"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExpiredStatus);
export default __webpack_public_path__ + "static/media/expiredStatus.77c6b530d92dda0b2c756c0e3a71ad51.svg";
export { ForwardRef as ReactComponent };